import { render } from "./UnscheduledStaff.vue?vue&type=template&id=4b17d419&scoped=true&ts=true"
import script from "./UnscheduledStaff.vue?vue&type=script&lang=ts"
export * from "./UnscheduledStaff.vue?vue&type=script&lang=ts"

import "./UnscheduledStaff.vue?vue&type=style&index=0&id=4b17d419&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b17d419"]])

export default __exports__